export default "/etc.clientlibs/pg/clientlibs/clientlib-site/resources/images/fb08930012183f9a0c8ce3c52b9051ed.svg";